<template>
  <div>
    <!------------------------->
    <div class="alert alert-info" role="alert">
      <h4 class="alert-heading">
        Rewind Preview!
      </h4>
    </div>
    <!------------------------->
    <scheduled-event-rewind-form />
  </div>
</template>

<script>
import ScheduledEventRewindForm from 'VueComponents/ScheduledEventRewindForm';

export default {
  components: {
    ScheduledEventRewindForm,
  },
};
</script>
